export enum AppRoute {
  LANDING = '/',
  APPLIANCE_DETAILS = '/appliance-details',
  MAINTENANCE = '/maintenance',
  MODEL_SERIAL = '/model-serial',
  PURCHASE_PRICE = '/purchase-price',
  ARRIVAL_DATE = '/arrival-date',
  PERSONAL_DETAILS = '/personal-details',
  QUOTE = '/quote',
  CHECKOUT = '/checkout',
  CONFIRMATION = '/confirmation',
  ERROR = '/error',
  TWO_YEAR_PARTS = '/2yearparts',
}
